(function () {
    'use strict';
    angular
        .module('commissionsPayment')
        .controller('CommissionsPaymentListController', CommissionsPaymentListController);
    CommissionsPaymentListController.$inject = ['$uibModal', '$state', '$stateParams', 'CommissionService','$scope','$timeout', 'SellerService'];
    function CommissionsPaymentListController($uibModal, $state, $stateParams, CommissionService, $scope, $timeout, SellerService) {
        var vm = this;
        vm.invoiceControlId = '';
        vm.invoices = '';
        vm.sellerSelected = '';
        vm.sellers = '';
        vm.status = {id : 'all', name : '--- All ---'};
        vm.statusList = [{id : -1, name : '--- All ---'}, {id : 'paid', name : 'Paid'}, {id : 'waiting', name : 'Waiting'}, {id : 'authorized', name : 'Authorized'}];
        vm.invoiceDueDate = {startDate: null, endDate: null};
        vm.invoicePaymentDate = {startDate: null, endDate: null};
        vm.commissionDate = {startDate: null, endDate: null};
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };
        vm.getCommissions             = getCommissions;
        vm.loadSellers                = loadSellers;  
        vm.clear                      = clear;
        vm.openInvoiceCommissions     = openInvoiceCommissions;
        vm.remove                     = remove;

        vm.getStatusClass = getStatusClass;

        vm.selectOptionAll = [{
            name: '--- All ---'
        }];
        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems;
        vm.currentPage;
        vm.itemsPerPage;
        vm.page = 1;

        activate();

        function activate() {
             vm.getCommissions();
             vm.loadSellers();
        }

        function getCommissions() {
            var query = {};
            query['paginate'] = 20;
            if (vm.invoiceControlId !== '') {
                query['control'] = vm.invoiceControlId;
            }
            if (vm.sellerSelected.id > -1) {
                query['seller_id'] = vm.sellerSelected.id;
            }
            if (vm.status.id !== 'all' ) {
                query['status'] = vm.status.id;
            }
            if (vm.sellerSelected.id !== 'all' ) {
                query['seller'] = vm.sellerSelected.id;
            }
            if ((vm.invoiceDueDate.startDate !== null ) && (vm.invoiceDueDate.endDate !== null)) {
                query['due_date'] = vm.invoiceDueDate;
            }
            if (vm.invoicePaymentDate.startDate !== null && vm.invoicePaymentDate.endDate !== null) {
                query['payment_date'] = vm.invoicePaymentDate;
            }
            if (vm.commissionDate.startDate !== null && vm.commissionDate.endDate !== null) {
                query['commission_date'] = vm.commissionDate;
            }
            query['page'] = vm.page;
            CommissionService.getCommissionsByFilter(query).then(function(response) {
                vm.invoices = response.data.data;
                vm.totals_by_currency = response.data.totals_by_currency;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {
            });
        }

        function loadSellers() {
            SellerService.getStaff().then(function(response) {
                vm.sellers = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function clear() {
            vm.invoiceDueDate = {startDate: null, endDate: null};
            vm.invoicePaymentDate = {startDate: null, endDate: null};
            vm.commissionDate = {startDate: null, endDate: null};
            vm.status = {id : 'all', name : '--- All ---'};
            vm.invoiceControlId = '';
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getCommissions();
        }

        function remove(invoice) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this invoice?')
                .set('onok', function (){
                    CommissionService.destroy(invoice.id).then(function() {
                        vm.invoices.splice(vm.invoices.indexOf(invoice), 1);
                        alertify.notify('Commissions removed', 'success', 3);
                    });
                })
                .show();
        }

        function openInvoiceCommissions(invoice_commission) {
            $uibModal.open({
                templateUrl: 'templates/commissions-payment/invoiceCommissionModal/invoiceCommissionModal.html',
                controller: 'InvoiceCommissionModalController',
                controllerAs:'invoiceCommissionModal',
                size:'lg',
                resolve:
                    {
                        invoice_commission : function () {
                            return invoice_commission;
                        },
                        getInvoicesCommissions : function() {
                            return vm.getCommissions;
                        }
                    }
            });
        }

        function getStatusClass(status) {
            if (status === 'waiting')
                return 'label-default';
            else if (status === 'authorized')
                return 'label-warning';
            else if (status === 'paid')
                return 'label-success';
        }
    }
})();